import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  background: #EAEDF0;
  border-radius: 5px;
  margin-top: 20px;
  padding: 0 34px;

  span {
    color: #44566C;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const TableHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 38px;
`;

export const SkeletonCheckbox = styled.div`
  width: 16px;
  height: 16px;
  background: #D9D9D9;
  border-radius: 2px;
`;

export const SkeletonRows = styled.div`
  width: 100%;
`;

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  background: #FFFFFF;
  border: solid 1px #EAEDF0;
  border-radius: 5px;
  margin-top: 6px;
  padding: 0 34px;
  gap: 38px;
`;

export const SkeletonIcon = styled.div`
  width: 24px;
  height: 24px;
  background: #F0F0F0;
  border-radius: 4px;
`;

export const SkeletonText = styled.div`
  width: 334px;
  height: 12px;
  background: #F0F0F0;
  border-radius: 2px;
`;

export const BoxCard = styled.div`
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 16px;
  padding: 40px 32px 36px;
  text-align: center;
  max-width: 480px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 50px));
  z-index: 10;
`;

export const IconsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-bottom: 24px;
`;

export const AppIconWrapper = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
`;

export const DashedLine = styled.div`
  width: 28px;
  border-top: 2px dashed #d9d9d9;
  flex-shrink: 0;
`;

export const WarningDot = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 24px;
  line-height: 1.4;
`;

export const Description = styled.p<{ secondary?: boolean }>`
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.6;
  margin: 0 0 ${({ secondary }) => (secondary ? '20px' : '10px')};
`;

export const EmailBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 28px;

  span {
    color: #262626;
    font-weight: 700;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  .ant-btn-primary {
    background-color: var(--Primary-primary, #3547C8);
    border-color: var(--Primary-primary, #3547C8);
    border-radius: 8px;
    height: 38px;
    padding: 0 18px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .ant-btn-default {
    border-radius: 8px;
    height: 38px;
    padding: 0 16px;
    font-weight: 500;
    color: #595959;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
`;
